import React, { useContext } from 'react';
import styled, { css } from 'styled-components';

import Link from '../../base/Link/Link';
import { Button } from '../../base/Button/Button';
import { TypographyContext } from '../Typography/config';

import chevron from '../../assets/icons/Chevron_BLK.svg';
import chevronWhite from '../../assets/icons/Chevron_WHT.svg';
import burgerBlack from '../../assets/icons/Burger_icon_blk.png';
import burgerWhite from '../../assets/icons/Burger_icon_wht.png';

import { theme } from '../../styles/theme';
import isDarkColour from '../../utils/isDarkColour';

// Gatsby Link components ignore any onClick passed in and just
// redirect to /undefined in the absence of a href prop.
// This is just a workaround currently, should be split
// into Link and Button components in the future, as it impacts
// a lot of buttons across the whole website
const makeComponent = (props) => {
  const isButton = !!props.onClick;
  const Component = isButton ? Button : Link;

  return styled(Component)`
    position: relative;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;

    font-family: 'FoundersGrotesk' !important;
    font-weight: bold;
    text-decoration: none;
    color: ${theme.colors.black};
    font-size: ${theme.fontSizes[1]};
    line-height: ${theme.lineHeights.body};

    @media only screen and (min-width: ${theme.breakpoint.md}) {
      font-size: ${theme.fontSizes[2]};
    }

    border: 1px solid ${theme.colors.black};
    background-color: transparent;

    width: auto;
    padding: 0.55em 1em 0.5em;

    cursor: pointer;
    transition: all 400ms ease-in-out;

    &:hover {
      color: ${theme.colors.lightText};
      background-color: ${theme.colors.black};
    }

    &:focus {
      outline: none;
    }

    /* Basic icon support styles */

    &:after,
    &:before {
      position: absolute;
      font-size: ${theme.fontSizes[1]};
      line-height: ${theme.lineHeights.body};

      @media only screen and (min-width: ${theme.breakpoints.md}) {
        font-size: ${theme.fontSizes[2]};
      }
      top: 50%;
      right: 11px;
      transform: translateY(-50%);
      content: '';
      display: none;
      width: 18px;
      height: 21px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      transition: all 400ms ease-in-out;
    }

    ${(props) =>
      isDarkColour(props.colourScheme) &&
      css`
        color: ${theme.colors.lightText};
        border-color: ${theme.colors.background};
        background-color: transparent;

        &:hover {
          color: ${theme.colors.black};
          background-color: ${theme.colors.background};

          &:after {
            opacity: 0;
          }
        }
      `} /* Chveron style */ ${(props) =>
      props.arrow &&
      css`
        padding-right: calc(3em + 1em);

        &:before {
          display: inline-block;
          background-image: url(${chevronWhite});
          height: 15px;
          opacity: 1;
        }

        &:after {
          display: inline-block;
          background-image: url(${chevron});
          height: 15px;
        }

        &:hover {
          &:after {
            opacity: 0;
          }
        }
      `}

    ${(props) =>
      props.arrow &&
      isDarkColour(props.colourScheme) &&
      css`
        &:before {
          background-image: url(${chevron});
        }

        &:after {
          background-image: url(${chevronWhite});
          opacity: 1;
        }
      `} /* Nav/burger style */ ${(props) =>
      props.nav &&
      css`
        padding-right: calc(3em + 1em);
        border: none;

        @media (min-width: ${theme.breakpoint.lg}) {
          display: none;
          border: 1px solid ${theme.colors.black};
        }

        &:before {
          display: inline-block;
          background-image: url(${burgerWhite});

          opacity: 1;
        }

        &:after {
          display: inline-block;
          background-image: url(${burgerBlack});
        }

        &:hover {
          color: ${theme.colors.text};
          background-color: ${theme.colors.background};

          @media (min-width: ${theme.breakpoint.lg}) {
            color: ${theme.colors.lightText};
            background-color: ${theme.colors.black};

            &:after {
              opacity: 0;
            }
          }
        }
      `}

    ${(props) =>
      props.nav &&
      isDarkColour(props.colourScheme) &&
      css`
        &:after {
          background-image: url(${burgerWhite});
          opacity: 1;
        }
      `}
  `;
};

const ColouredButton = (props) => {
  const { colourScheme } = useContext(TypographyContext);
  const Component = makeComponent(props);

  return (
    <Component {...props} colourScheme={props.colourScheme || colourScheme} />
  );
};

export default ColouredButton;
